export default __webpack_public_path__ + "static/media/movie3.14741fd1.png";